import { Patch } from 'rfc6902';
import requestJson from '../../../modules/requestJson';
import { AppProjectDraft } from '../types';

/**
 * Stores the given patch as an app project draft to the server.
 * Note: any request error is ignored and this returns null if storing fails.
 */
export default async function storeAppProjectDraft(
  appId: number | string,
  baseDescriptorVersion: string,
  patch: Patch,
): Promise<AppProjectDraft | null> {
  try {
    return await requestJson('POST', `/app-editor/v1/projects/${encodeURIComponent(appId)}/draft`, {
      base_descriptor_version: baseDescriptorVersion,
      patch,
    });
  } catch {
    return null;
  }
}
